<template>
    <!--@formatter:off-->
    <div>
        <div class="after_tit_area">
            <div class="tit_bx">
                <h2 class="tit">
                    <span class="txt">
                        개인정보 수집·이용 동의
                    </span>
                    <IconRequired/>
                </h2>
            </div>
        </div>
        <div class="bx_lst_checkbox">
            <ul class="lst_checkbox">
                <li>
                    <span class="bx_input">
                        <input type="radio" name="agreement_option" id="agreement_option1" class="inp_rdo"
                               :checked="isDenied">
                        <label for="agreement_option1" class="txt_checkbox"
                               @click="confirmAgreementDeny">동의하지 않습니다.</label>
                    </span>
                </li>
                <li>
                    <span class="bx_input">
                        <input type="radio" name="agreement_option" id="agreement_option2" class="inp_rdo"
                               :checked="isAllAgreementsChecked">
                        <label for="agreement_option2" class="txt_checkbox"
                               @click="confirmAgreementAgreeAll">모두 동의합니다</label>
                    </span>
                </li>
            </ul>
        </div>
        <div :style="{
            paddingTop: '12px'
        }">
            <EnrolmentResponseAgreement
                v-for="agreement in agreements"
                :agreement="agreement"
                :key="agreement.questionNo"
                />
        </div>
        <ul :style="{
            marginTop: '9px',
            paddingLeft: '11px',
        }">
            <li :style="{ color:'#999', fontSize:'12px'}">
                개인정보 수집 및 이용에 따른 동의를 거부할 수 있으나,
                <br>
                동의를 거부할 경우 수강신청이 제한될 수 있습니다.
            </li>
        </ul>
    </div>
    <!--@formatter:on-->
</template>

<script>
import {createNamespacedHelpers} from 'vuex';
import {ENROLMENT_RESPONSE_NAMESPACE} from '@/common/store';
import CommonCheckbox from '@iamteacherpc/assets/common/component/CommonCheckbox.vue';
import IconRequired from '@iamteacherpc/assets/common/icon/IconRequired.vue';
import EnrolmentResponseAgreement from '@iamteacherpc/components/response/EnrolmentResponseAgreement.vue';
import {
    CHECK_ALL_AGREEMENTS,
    IS_ALL_AGREEMENTS_CHECKED,
    SHOW_ERROR,
    UNCHECK_ALL_AGREEMENTS,
} from '@common/store/modules/enrolment/response';
import {SURVEY_ANSWER_STATE_TYPE} from '@common/consts/response';

const {mapState, mapGetters, mapActions} = createNamespacedHelpers(ENROLMENT_RESPONSE_NAMESPACE);

export default {
    name: 'EnrolmentResponseAgreementList',
    components: {EnrolmentResponseAgreement, IconRequired, CommonCheckbox},

    emits: ['change-answer-state'],
    computed: {
        ...mapState({
            agreements: state => state.survey.contents.agreements,
            checkedAgreementsNos: state => state.options.checkedAgreementsNos,
            answerStateType: state => state.survey.answerStateType,
            isPreview: state => state.options.isPreview,
        }),

        ...mapGetters({
            isAllAgreementsChecked: IS_ALL_AGREEMENTS_CHECKED,
        }),
    },
    data() {
        return {
            isDenied: false, // 모든동의문거부 버튼은 직접 해당버튼을 눌렀을 때만 활성화 되고 그 외에는 활성화 되지 않음
        };
    },
    watch: {
        checkedAgreementsNos() {
            if (this.checkedAgreementsNos.length > 0) {
                this.isDenied = false;
                // this.$emit('change-answer-state', SURVEY_ANSWER_STATE_TYPE.ANSWER);
            }
        },
    },
    methods: {
        ...mapActions({
            showError: SHOW_ERROR,
            checkAllAgreements: CHECK_ALL_AGREEMENTS,
            uncheckAllAgreements: UNCHECK_ALL_AGREEMENTS,
        }),

        // 모든 동의문 거부
        confirmAgreementDeny() {
            if (this.isPreview) {
                this.isDenied = true;
                this.uncheckAllAgreements();
                return;
            }
            if (this.answerStateType === SURVEY_ANSWER_STATE_TYPE.ANSWER) {
                this.$showAlert({
                    desc: '강좌 신청 완료 후에는 개인정보 수집 및 이용 동의를 변경할 수 없습니다.',
                    okText: this.$t('common_confirm'),
                    ok: async () => {
                        //...
                    },
                });
                return;
            }
            this.isDenied = true;
            this.uncheckAllAgreements();
        },
        // 모든 동의문 동의
        confirmAgreementAgreeAll() {
            this.checkAllAgreements();
        },
    },
};
</script>

<style scoped>
li::marker {
    font-size: 10px;
    content: '※ '
}
</style>
